/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_PauseInputs */

const th_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดชั่วคราว`)
};

const en_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const ja_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一時停止`)
};

const zh_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂停`)
};

const es_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar`)
};

const pt_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar`)
};

const id_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeda`)
};

const fr_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const tl_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-pause`)
};

const vi_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạm dừng`)
};

const ko_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일시정지`)
};

const de_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const ru_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза`)
};

const tr_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duraklat`)
};

const it_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa`)
};

const pl_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstrzymaj`)
};

const uk_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза`)
};

const hi_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोकें`)
};

const ar_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيقاف مؤقت`)
};

const ms_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeda`)
};

const bn_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থামান`)
};

const zh_tw2_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫停`)
};

const zh_hk2_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫停`)
};

const ur_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روکیں`)
};

const fa_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مکث`)
};

const sw_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simamisha`)
};

const nl_video_pause = /** @type {(inputs: Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze`)
};

/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Video_PauseInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_pause = /** @type {((inputs?: Video_PauseInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_PauseInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_pause(inputs)
	if (locale === "ja") return ja_video_pause(inputs)
	if (locale === "zh") return zh_video_pause(inputs)
	if (locale === "es") return es_video_pause(inputs)
	if (locale === "pt") return pt_video_pause(inputs)
	if (locale === "id") return id_video_pause(inputs)
	if (locale === "fr") return fr_video_pause(inputs)
	if (locale === "tl") return tl_video_pause(inputs)
	if (locale === "vi") return vi_video_pause(inputs)
	if (locale === "ko") return ko_video_pause(inputs)
	if (locale === "de") return de_video_pause(inputs)
	if (locale === "ru") return ru_video_pause(inputs)
	if (locale === "tr") return tr_video_pause(inputs)
	if (locale === "it") return it_video_pause(inputs)
	if (locale === "pl") return pl_video_pause(inputs)
	if (locale === "uk") return uk_video_pause(inputs)
	if (locale === "hi") return hi_video_pause(inputs)
	if (locale === "ar") return ar_video_pause(inputs)
	if (locale === "ms") return ms_video_pause(inputs)
	if (locale === "bn") return bn_video_pause(inputs)
	if (locale === "zh-TW") return zh_tw2_video_pause(inputs)
	if (locale === "zh-HK") return zh_hk2_video_pause(inputs)
	if (locale === "ur") return ur_video_pause(inputs)
	if (locale === "fa") return fa_video_pause(inputs)
	if (locale === "sw") return sw_video_pause(inputs)
	if (locale === "nl") return nl_video_pause(inputs)
	return en_video_pause(inputs)
});